import { useTheme } from "app/shared";
import React from "react";
import TriangleIcon from "./icon";
import styles from "./welcome-banner.module.scss";

interface WelcomeBannerProps {
  data: {
    title: string;
    description: string;
  };
}

const WelcomeBanner: React.FC<WelcomeBannerProps> = ({ data }) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.welcomeBanner} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <div className={styles.content}>
        <TriangleIcon className={styles.icon} />
        <div
          className={`${styles.text} ${
            theme === "dark" ? styles.darkTheme : ""
          }`}
        >
          <h1>{data.title}</h1>
          <p>{data.description}</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
